import globals from '../globals'; 

export const getHeaders = (includeToken = false, isMultipart = false) => {
  const headers = {};

  // DO NOT set Content-Type when using FormData
  if (!isMultipart) {
    headers['Content-Type'] = 'application/json';
  }

  const businessId = localStorage.getItem('business_id');
  if (businessId) {
    headers['businessId'] = businessId;
  }

  if (includeToken) {
    const token = localStorage.getItem('authToken');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  if (includeToken && businessId) {
    headers['Business-Id'] = businessId;
  }
  return headers;
};

//Add Subscription Plans
export const StoreSubscriptionPlans = async (data) => {
  const link = globals.baseUrl + '/store-update-plan';

  const body = JSON.stringify({
    ...(data.id && { id: data.id }),
    name: data.name,
    featured_plan: data.featured_plan,
    color: data.color,
    short_description: data.short_description,
    no_of_users: data.no_of_users,
    interval: data.interval,
    free_plan: data.free_plan,
    price: data.price,
    custom_features: data.custom_features,
  });

  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(true),
    body,
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};

//Get Subscription Plans
export const GetSubscriptionPlans = async (data) => {
  const link = globals.baseUrl + '/get-plans';

  const body = JSON.stringify({
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    previousPageIndex: data.previousPageIndex,
  });

  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(true),
    body,
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};

// Delete Subscription Plans
export const deletePlan = async (dataId) => {
  const link = globals.baseUrl + '/delete-plan';

  const body = JSON.stringify({
    id: dataId,
  });

  const response = await fetch(link, {
    method: 'POST',
    headers: getHeaders(true),
    body,
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error);
  }

  return response;
};